import { useMemo } from 'react'
import { getWaterlinePermissions, getWaterlineUserPermissions } from '../views/practice/waterline/utils'
import { selectCurrentUser } from '../redux/user'
import { useAppSelector } from '../redux/store'

const useWaterlinePermissions = () => {
  const user = useAppSelector(selectCurrentUser)

  const permissions = useMemo(() => {
    const waterlinePermissions = getWaterlinePermissions()
    const userPermissions = getWaterlineUserPermissions(user, waterlinePermissions)

    return userPermissions
  }, [user])

  return permissions
}

export default useWaterlinePermissions
